import { wsClient } from './wsClient';

class SocketInstance {
  client: wsClient | null = null;

  initSockets() {
    this.client = new wsClient();
  }
  refreshSockets() {
    this.client?.refreshSocket();
  }
  disconnect() {
    this.client?.closeSocket();
  }
}

export const wsService = new SocketInstance();
